import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'
import { removeTypename as removeTypenameUtil } from '../utils/removeTypename'

function handleGraphQLError(error, { type, name, variables }) {
  Vue.prototype.$sentry.captureException(error, {
    tags: { graphql_type: type, graphql_name: name },
    extra: {
      url: window.config?.GrapgQlUrl,
      type,
      name,
      variables,
      userId: Vue.prototype.$auth?.user?.sub,
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      headers: error?.response?.headers,
      response: error?.response?.data,
      message: error.message,
      code: error.code,
    }
  })
  Vue.prototype.$log_error(error.message, { name, variables })
}

/**
 * @param {string[]} ignoredErrorCodes очікувані коди GraphQL-помилок запиту (extensions.code),
 *   які не логуються (напр. ChatDoesNotExist — чату ще немає)
 */
export default  async function ( {environment, type, name, variables, way, callback, has_catch, catch_callback, removeTypename = true, ignoredErrorCodes = []} ) {
  let info = await import(way + name + '.gql')
  let apolo = await getApolloClient(environment)
  let request = async ()  => {
    try {
      if (type == 'query') {
        const res = await apolo
          .query({
            query: gql`${ info }`,
            variables,
            errorPolicy: 'all'
          })
        const loggedErrors = res.errors?.filter(error => !ignoredErrorCodes.includes(error.extensions?.code)) || []
        if (loggedErrors.length) {
          handleGraphQLError(
            Object.assign(new Error(loggedErrors[0].message), { graphQLErrors: res.errors }),
            { type, name, variables }
          )
        }
        return res.data?.[name] ?? res
      } else {
        return await apolo
          .mutate({
            mutation: gql`${ info }`,
            variables
          })
      }
    } catch (error) {
      handleGraphQLError(error, { type, name, variables })
      throw error
    }
  }
  return await request()
    .then(res => {
      try {
        const result = res?.data ? res?.data[name] : res
        const cleaned = removeTypename ? removeTypenameUtil(result) : result
        if (callback) {
          if (res?.data) {
            res.data[name] = cleaned
            return callback(res)
          }
          return callback(cleaned)
        } else {
          return cleaned
        }
      } catch (_) {
        return
      }
    })
    // request() відхиляється лише зі свого catch, де помилку вже залоговано — повторно не логуємо
    .catch(error => {
      try {
        if (catch_callback) {
          return catch_callback(error)
        } else if (has_catch) {
          // уже залогировано
        } else {
          throw error
        }
      } catch (_) {
        throw error
      }
    })
}
